export default "__VITE_ASSET__CHxUf3xx__"